import React from "react";
import SceneItem from "./SceneItem";

const SceneList = ({ scenes, visualStatuses = {}, onCopyScene, onEditScene, onRetryVisual, onRegenerateVisual }) => {
  const sceneList = Array.isArray(scenes) ? scenes : [];

  if (sceneList.length === 0) {
    return (
      <p className="text-theme-text opacity-70 text-sm py-4">No scenes in this script yet.</p>
    );
  }

  return (
    <ol className="relative list-none p-0 m-0">
      {sceneList.map((scene, idx) => {
        const sceneNumber = scene.scene_number ?? idx + 1;
        const visualStatus =
          visualStatuses[sceneNumber] ||
          (scene.image_url || scene.image_hash ? undefined : "queued");

        return (
          <SceneItem
            key={scene.scene_number != null ? `scene-${scene.scene_number}` : `scene-idx-${idx}`}
            scene={scene}
            index={idx}
            isLast={idx === sceneList.length - 1}
            imageUrl={scene.image_url}
            visualStatus={visualStatus}
            onCopyScene={onCopyScene}
            onEditScene={onEditScene}
            onRetryVisual={() => onRetryVisual?.(sceneNumber)}
            onRegenerateVisual={onRegenerateVisual}
          />
        );
      })}
    </ol>
  );
};

export default SceneList;
